export enum routes {
  HOME = 'ch-sidebar.btn-dashboard',
  CURSOS = 'ch-sidebar.btn-my-courses',
  SERVICES = 'ch-sidebar.btn-services',
  VIDEO_TUTORIALS = 'ch-sidebar.btn-video-tutorials',
  CHAT = 'ch-sidebar.btn-chat',
  COURSE_CAREER = 'ch-sidebar.btn-courses-and-careers',
  WEBINARS = 'home.footer.webinars',
  PROFILE = 'ch-sidebar.btn-profile',
  COURSES = 'ch-sidebar.btn-more-courses',
  PREMIUM_CAMP = 'ch-sidebar.btn-premium-camp',
  REFERRALS = 'ch-header-dropdown.btn-friend-referral',
  PERKS = 'ch-sidebar.btn-perks',
  NOTIFICATIONS = 'ch-sidebar.btn-notifications',
  JOB_MARKET = 'ch-sidebar.btn-job-offers',
  MY_JOURNEY = 'ch-sidebar.btn-my-journey'
}
